<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-list-view" class="data-list-container">
    <etapa-caso-sidebar
      v-if="addNewDataSidebar"
      :propModeView="sidebarViewMode"
      :isSidebarActive="addNewDataSidebar"
      @closeSidebar="toggleDataSidebar"
      @refresh="updateTable"
      :data="sidebarData"
      :licitacionProp="licitacionProp"
    />

    <vs-table
      ref="table"
      pagination
      :max-items="itemsPerPage"
      search
      :data="etapas_caso"
    >
      <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between"
      >
        <div
          class="flex flex-wrap-reverse items-center data-list-btn-container"
        >
          <!-- ADD NEW -->
          <!-- <div
                        class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"
                        @click="addNewData">
                        <feather-icon icon="PlusIcon" svgClasses="h-4 w-4"/>
                        <span class="ml-2 text-base text-primary">Agregar Nuevo</span>
                    </div>-->
        </div>

        <!-- ITEMS PER PAGE -->
        <vs-dropdown
          vs-trigger-click
          class="cursor-pointer mb-4 mr-4 items-per-page-handler"
        >
          <div
            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <span class="mr-2"
            >{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
              {{
                etapas_caso.length - currentPage * itemsPerPage > 0
                  ? currentPage * itemsPerPage
                  : etapas_caso.length
              }}
              de {{ queriedItems }}</span
            >
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage = 4">
              <span>4</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th :key="indexth" v-for="(row, indexth) in meta" v-if="row">
          <p class="product-name font-medium truncate">{{ row }}</p>
        </vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody>
        <vs-tr
          :data="tr"
          :key="indextr"
          v-for="(tr, indextr) in data"
          v-if="tr"
        >
          <vs-td>
            <p class="product-name font-medium truncate">
              {{ tr.idRequestPhaseStg }}
            </p>
          </vs-td>
          <vs-td>
            <p class="product-name font-medium truncate">{{ tr.phaseDescription }}</p>
          </vs-td>
          <vs-td>
            <p class="product-name font-medium truncate">
              {{ tr.stageDescription }}
            </p>
          </vs-td>
          <vs-td>
            <p class="product-name font-medium truncate">
              {{ tr.stageStatusDescription }}
            </p>
          </vs-td>
          <vs-td>
            <p class="product-name font-medium truncate">
              {{ tr.username ? tr.username : '-' }}
            </p>
          </vs-td>
          <vs-td>
            <p class="product-name font-medium truncate">
              {{ tr.registerDate }}
            </p>
          </vs-td>
          <vs-td>
            <p class="product-name font-medium truncate">
              {{ tr.requireApproval === 'Y' ? 'SI' : 'NO' }}
            </p>
          </vs-td>
          <vs-td class="whitespace-no-wrap">
            <template v-if="tr.canUserRegisterTime === 'Y'">
              <!-- <feather-icon
                icon="EyeIcon"
                svgClasses="w-5 h-5 hover:text-dark stroke-current"
                @click.stop="displayData(tr)"
              /> -->
              <feather-icon
                @click="openProcessStagesModal(tr.idRequestPhaseStg)"
                icon="PlayIcon"
                svgClasses="w-5 h-5 hover:text-success stroke-current"
              />
              <feather-icon
                icon="PauseIcon"
                svgClasses="w-5 h-5 hover:text-warning stroke-current"
                class="ml-2"
              />
              <feather-icon
                icon="SquareIcon"
                svgClasses="w-5 h-5 hover:text-danger stroke-current"
                class="ml-2"
              />
              <!-- <feather-icon
                icon="EditIcon"
                svgClasses="w-5 h-5 hover:text-primary stroke-current"
                class="ml-2"
                @click.stop="editData(tr)"
              />
              <feather-icon
                icon="TrashIcon"
                svgClasses="w-5 h-5 hover:text-danger stroke-current"
                class="ml-2"
                @click.stop="deleteData(tr.IDETAPA)"
              /> -->
            </template>

            <template v-else>
              <p class="product-name font-medium truncate">-</p>
            </template>
          </vs-td>
        </vs-tr>
        </tbody>
      </template>
    </vs-table>

    <vs-prompt
      :active.sync="showModal" title="Procesar etapas"
      acceptText="Aceptar" cancelText="Cancelar"
      @accept="processSelectedStages" @close="closeProcessStagesModal" @cancel="closeProcessStagesModal"
    >
        <p>¿Desea procesar más ordenes?</p>
        <vs-table>
          <tbody>
            <vs-tr
              :data="stagesList"
              :key="tr.idRequestPhaseStg"
              v-for="tr in stagesList"
              v-if="tr"
            >
              <vs-td>
                <input
                  type="checkbox"
                  :value="tr.idRequestPhaseStg"
                  @click="toggleStageSelection(tr.idRequestPhaseStg)"
                />
              </vs-td>
              <vs-td>
                <p class="product-name font-medium truncate">{{ tr.stageDescription }}</p>
              </vs-td>
            </vs-tr>
          </tbody>
        </vs-table>
    </vs-prompt>

  </div>
</template>

<script>
import EtapaCasoSidebar from '@/views/etapa-caso/EtapaCasoSidebar.vue'
import EtapaCasoModule from '@/store/etapa-caso-module/moduleDataList.js'
//import LocationEtapaLicitacionListView from '@/views/location-etapa-licitacion/LocationEtapaLicitacionListView.vue'

export default {
  props: {
    licitacionProp: {
      type: Object,
      default: () => {
      }
    },
    casoProp: {
      type: Object,
      default: () => {
      }
    }
  },
  components: {
    EtapaCasoSidebar
    // LocationEtapaLicitacionListView
  },
  created () {
    if (!EtapaCasoModule.isRegistered) {
      this.$store.registerModule('EtapaCasoModule', EtapaCasoModule)
      EtapaCasoModule.isRegistered = true
    }
    this.updateTable()
  },
  mounted () {
    this.isMounted = true
  },
  updated () {
    //console.log('etapas_caso', this.etapas_caso)
  },
  data () {
    return {
      selected: [],
      itemsPerPage: 4,
      isMounted: false,
      indexDelete: -1,
      showModal: false,
      stagesList: [],
      selectedStages: [],

      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {},
      sidebarViewMode: true
    }
  },
  computed: {
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    etapas_caso () {
      return this.$store.state.EtapaCasoModule.etapas_caso
    },
    meta () {
      return this.$store.state.EtapaCasoModule.meta
    },
    queriedItems () {
      return this.$refs.table
        ? this.$refs.table.queriedResults.length
        : this.etapas_caso.length
    },
    codigo_grupo () {
      return this.$store.state.EtapaCasoModule.codigo_grupo
    }
  },
  methods: {
    addNewData () {
      this.sidebarData = {}
      this.sidebarViewMode = false
      this.toggleDataSidebar(true)
    },
    deleteData (etapa_licitacionId) {
      this.indexDelete = this.etapas_caso.findIndex(
        (p) => p.IDETAPA === etapa_licitacionId
      )
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirmar eliminar',
        text: `¿Desea eliminar la etapa "${
          this.etapas_caso[this.indexDelete].NOMBRE
        }"?`,
        accept: this.deleteRecord,
        acceptText: 'Eliminar',
        cancelText: 'Cancelar'
      })
    },
    deleteRecord () {
      const idEtapaLicitacionTmp = this.etapas_caso[this.indexDelete].IDETAPA
      const nameEtapaLicitacionTmp = this.etapas_caso[this.indexDelete].NOMBRE
      this.$store
        .dispatch('EtapaCasoModule/removeEtapaCaso', idEtapaLicitacionTmp)
        .then(() => {
          this.$vs.notify({
            color: 'success',
            title: 'Etapa eliminada',
            text: `La etapa ${nameEtapaLicitacionTmp} ha sido eliminada del sistema.`
          })
          this.updateTable()
        })
        .catch((ex) => {
          this.$vs.dialog({
            color: 'danger',
            title: 'Error al actualizar datos',
            text: 'No es posible actualizar en la base de datos',
            acceptText: 'Aceptar',
            accept: console.log('Ex:', ex)
          })
        })
    },
    displayData (data) {
      // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
      this.sidebarData = data
      this.sidebarViewMode = true
      this.toggleDataSidebar(true)
    },
    editData (data) {
      // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
      this.sidebarData = data
      this.sidebarViewMode = false
      this.toggleDataSidebar(true)
    },
    displayView () {
      this.sidebarData = data
      this.toggleDataSidebar(true)
    },
    getOrderStatusColor (status) {
      if (status === 'on_hold') return 'warning'
      if (status === 'delivered') return 'success'
      if (status === 'canceled') return 'danger'
      return 'primary'
    },
    getPopularityColor (num) {
      if (num > 90) return 'success'
      if (num > 70) return 'primary'
      if (num >= 50) return 'warning'
      if (num < 50) return 'danger'
      return 'primary'
    },
    toggleDataSidebar (val = false) {
      this.addNewDataSidebar = val
    },
    updateTable () {
      this.$vs.loading()
      this.$store
        .dispatch(
          'EtapaCasoModule/getAllEtapasByCaso',
          this.$props.casoProp.id
        )
        .then(() => {
          this.$vs.loading.close()
        })
        .catch(() => {
          console.log('error updateTable')
          this.$vs.loading.close()
          this.$vs.dialog({
            color: 'danger',
            title: 'Error',
            text: 'No se pudo realizar la conexión, inténtelo de nuevo más tarde.',
            accept: 'Aceptar'
          })
        })
    },
    openProcessStagesModal (idRequestPhaseStg) {
      const currentPhase = this.etapas_caso.find(p => p.idRequestPhaseStg === idRequestPhaseStg)

      if (currentPhase.canUserRegisterTime !== 'Y') {
        this.$vs.dialog({
          color: 'danger',
          title: 'Error',
          text: 'No tiene permisos para registrar tiempo en esta fase.',
          acceptText: 'Aceptar'
        })
        return
      }

      for (const phase of this.etapas_caso) {
        if (phase.canUserRegisterTime === 'Y' && phase.idRequestPhaseStg !== idRequestPhaseStg) {
          this.stagesList.push(phase)
        }
      }

      this.selectedStages.push(currentPhase.idRequestPhaseStg)
      this.showModal = true
    },
    toggleStageSelection (idRequestPhaseStg) {
      const index = this.selectedStages.indexOf(idRequestPhaseStg)

      if (index !== -1) {
        this.selectedStages.splice(index, 1)
      } else {
        this.selectedStages.push(idRequestPhaseStg)
      }

      console.log('selectedStages', JSON.stringify(this.selectedStages))
      console.log('selectedStages length', JSON.stringify(this.selectedStages.length))
    },
    closeProcessStagesModal () {
      this.showModal = false
      this.stagesList = []
      this.selectedStages = []
    },
    createIdNugruPhase () {
      if (this.selectedStages.length === 0) {
        this.$vs.dialog({
          color: 'danger',
          title: 'Error',
          text: 'Debe seleccionar al menos una etapa para procesar.',
          acceptText: 'Aceptar'
        })
        return
      }

      this.$vs.loading()
      this.$store
        .dispatch(
          'EtapaCasoModule/createIdNugruPhase',
          {
            idUser: this.$store.state.auth.userDetails().id,
            agrupa: 'S'
          })
        .then(() => {
          this.$vs.loading.close()
        })
        .catch((error) => {
          console.log('createIdNugruPhase error', error)
          this.$vs.loading.close()
          this.$vs.dialog({
            color: 'danger',
            title: 'Error',
            text: 'Se presento un error al crear el código de agrupación.',
            accept: 'Aceptar'
          })
        })
    },
    processSelectedStages () {
      if (this.selectedStages.length > 1) {
        this.createIdNugruPhase()
      }

      console.log('codigo_grupo', this.codigo_grupo ? this.codigo_grupo : -1)

      const payload = {
        idUser: this.$store.state.auth.userDetails().id,
        idRequest: this.$props.casoProp.id,
        idRequestPhaseStg: this.selectedStages[0],
        idNugruPhaseStg: this.codigo_grupo ? this.codigo_grupo : -1
      }
      console.log('payload', JSON.stringify(payload))

      this.$store
        .dispatch(
          'EtapaCasoModule/processRequestByMultiPhase',
          payload)
        .then((response) => {
          console.log('processSelectedStages', JSON.stringify(response.data))
          this.$vs.loading.close()
        })
        .catch((error) => {
          console.log('processSelectedStages error', error)
          this.$vs.loading.close()
          this.$vs.dialog({
            color: 'danger',
            title: 'Error',
            text: 'Se presento un error al procesar las ordenes seleccionadas.',
            accept: 'Aceptar'
          })
        })

      this.showModal = false
      this.stagesList = []
      this.selectedStages = []
    }
  }
}
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    /*
              Below media-queries is fix for responsiveness of action buttons
              Note: If you change action buttons or layout of this page, Please remove below style
            */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;

      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);

        td {
          padding: 20px;

          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }

          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }

        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }

      th.td-check {
        padding: 0 15px !important;
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
